import React from "react";

import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../context/ProgressBarContext";
import { BreakpointIcon } from "../components/BreakpointIcon";

interface BreakpointIconsProps {
  children?: React.ReactNode;
}

export const BreakpointIcons = ({ children }: BreakpointIconsProps) => {
  const { state } = useProgressBarContext();

  return (
    <Icons className={"ig-icon-bar"}>
      <Content className={"ig-bar"}>{children}</Content>
      {state.breakpoints.map((b, index) => (
        <Icon key={index} breakpoint={b} />
      ))}
    </Icons>
  );
};

const Icons = styled("div")(() => {
  const { state } = useProgressBarContext();
  const justifyContent =
    state.breakpoints.length === 1 ? "end" : "space-between";
  return {
    position: "relative",
    display: "flex",
    justifyContent,
  };
});

const Content = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const Icon = styled(BreakpointIcon)({
  width: 0,
});
